
import {getViewKeys} from '../api/getViewKeys';
import {setGetViewKeysAction} from '../action';

const setGetViewKeys = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getViewKeys(params);

            if (data.status === 'success') {
              
                dispatch(setGetViewKeysAction({
                    qiwi_public_key: data.data.public_key,
                    qiwi_secret_key: data.data.secret_key,
                    qiwi_oauth: data.data.oauth,
                    max_amount_for_withdrawals: data.data.max_amount_for_withdrawals,
                    count_withdrawals_of_day: data.data.count_withdrawals_of_day,
                    amountSum: data.amount,
                    wallet: data.data.wallet,
                    wallet_key: data.data.wallet_key
                }));
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetViewKeys
}